<a [href]="url" target="_blank">
    <ng-content></ng-content>
</a>